<template>
    <div key="attachment">
        <b-modal v-model="isVisible" hide-footer>
            <b-img
                :src="model && model.url"
                fluid
                alt="Responsive image"
            ></b-img>
            <br />
            <div>
                <b-button
                    variant="warning"
                    v-if="hasPermissionDelete"
                    @click="deleteAttachment(model.hash)"
                    >Delete</b-button
                >
            </div>
        </b-modal>

        <b-row>
            <b-col cols="4">
                <b-form-file
                    id="uploadData"
                    @change="createAttachment"
                ></b-form-file>
            </b-col>
        </b-row>

        <b-container fluid class="p-4 mt-4 bg-dark">
            <b-row>
                <b-col v-for="(item, index) in attachments" :key="index" md="3">
                    <b-button @click="setModel(item)">
                        <b-img
                            thumbnail
                            fluid
                            :src="item.url"
                            alt="Image 1"
                        ></b-img>
                    </b-button>
                </b-col>
                <b-col v-if="!attachments.length">
                    <h4 class="text-white">No Attachments Submitted</h4>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'orders-attachments',

    mixins: [popupMixins, permissionsMixins],

    data() {
        return {
            submitting: false,
            model: null,
            isVisible: false,
        }
    },
    computed: {
        order() {
            return this.$store.state.orders.item
        },
        attachments() {
            return this.$store.state.orderAttachmentsStore.attachments
        },
    },
    watch: {
        'order.attachments': {
            handler: function (items) {
                this.storeAttachments(items)
            },
            deep: true,
        },
    },
    mounted() {
        this.$store.dispatch('js_report/fetchCredentials')
        const { attachments } = this.order
        this.storeAttachments(attachments)
    },
    methods: {
        storeAttachments(attachments) {
            attachments = (attachments || []).map(x => {
                if (x.url.indexOf(this.$OMSOldStorageUrl) === 0) {
                    x.url = x.url.replace(
                        this.$OMSOldStorageUrl,
                        this.$OMSStorageUrl
                    )
                }
                return x
            })
            this.$store.dispatch(
                'orderAttachmentsStore/load',
                attachments || []
            )
        },

        setModel(item) {
            console.log('item', item)
            this.model = { ...item }
            this.isVisible = true
        },

        createAttachment(event) {
            console.log('upload event', event)
            const $this = this
            if (!navigator.geolocation) {
                console.log('problem with navigator')
                $this.doToast(
                    'Error!',
                    'Error Adding Attachment! Need Permissions to Get Coordinates',
                    'danger'
                )
            } else {
                navigator.geolocation.getCurrentPosition(async p => {
                    try {
                        $this.submitting = true
                        console.log('coordinates', p)
                        const lat = p.coords.latitude
                        const long = p.coords.longitude

                        console.log(event.target.files)
                        const { key, name } = await $this.$store.dispatch(
                            's3files/s3upload',
                            event.target.files
                        )

                        const url = `${$this.$OMSStorageUrl}/${key}`
                        console.log({ key, name, url })

                        this.$store.dispatch('orderAttachmentsStore/merge', {
                            url,
                            lat,
                            long,
                        })
                    } catch (error) {
                        console.error('addAttachement', error)

                        $this.doToast(
                            'Error!',
                            'Error Storing Attachment!',
                            'danger'
                        )
                    } finally {
                        $this.submitting = false
                    }
                })
            }
        },
        deleteAttachment(hash) {
            this.$store.dispatch('orderAttachmentsStore/delete', hash)
            this.isVisible = false
        },
    },
}
</script>

<style lang="scss" scoped>
</style>